import { StatCard } from "./StatCard";

export const StatsGrid = ({ stats }) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 sm:gap-6">
            {stats.map((stat, i) => (
                <StatCard key={stat.id} stat={stat} delay={i * 0.1} />
            ))}
        </div>
    );
};
